export default __webpack_public_path__ + "static/media/profilepage-gifthist-nodata.856a8924.svg";